import React from "react";
import {
	Grid,
	Card,
	CardHeader,
	CardActions,
	CardContent,
	Typography,
	Divider,
	Button,
	Container,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import events from "data/events.json";

import { useAuth } from "contexts/auth-context";

const Event = (props) => {
	const { date, image, source, priority, title, text, actions } = props;
	return (
		<Card style={{ maxWidth: 900, margin: "auto", marginBottom: 8 }}>
			<CardHeader
				title={title}
				subheader={dayjs(date).format("MMM DD YYYY")}
			></CardHeader>
			<CardContent>
				<Grid container direction="row" spacing={2}>
					<Grid item xs={12} sm={6} md={4}>
						{image && (
							<img
								src={`${process.env.PUBLIC_URL}${image}`}
								style={{ width: "100%" }}
							></img>
						)}
						{source && (
							<Typography variant="caption">Credit: {source}</Typography>
						)}
					</Grid>
					<Grid item xs={12} sm={6} md={8}>
						<Typography>{text}</Typography>
					</Grid>
				</Grid>
			</CardContent>
			{actions && (
				<CardActions style={{ display: "flex", flexDirection: "row" }}>
					{actions?.map(({ href, text }, i) => (
						<Button
							href={href}
							// style={{ whiteSpace: "nowrap" }}
							variant="outlined"
						>
							{text}
						</Button>
					))}
				</CardActions>
			)}
		</Card>
	);
};
function Workshops() {
	const { user } = useAuth();
	return (
		<Container maxWidth={"lg"} maxWidthLg={800}>
			<CardHeader
				title={
					<Typography variant="h4" align="center" gutterBottom component={"h1"}>
						City@UMD News and Events
					</Typography>
				}
				action={
					user && (
						<Button component={Link} to="/news/upload">
							Upload New Event
						</Button>
					)
				}
			></CardHeader>

			<Divider style={{ margin: 4 }} />
			{events &&
				events
					.sort((a, b) => new Date(b.date) - new Date(a.date))
					.map((event, i) => <Event key={i} {...event} />)}
			<Divider />
			<h1 className="mainTitle text-center">Workshops</h1>
			<hr />
			<h4>
				City@UMD faculty are involved with and/or are providing the following
				workshops:
			</h4>
			<br />
			<div>
				<h2>Community Immunity to Pathogens and Air Quality Threats</h2>
				<p>
					In December 2018, researchers form University of Texas at Austin,
					University of California Berkeley and Morgan State University were
					hosted by their colleagues at the University of Maryland to envision
					an engineering system capable of addressing pathogen and air quality
					threats in indoor environments.
				</p>
				<a href="https://www.nsf.gov/pubs/2019/nsf19503/nsf19503.htm">
					<button className="btn btn-default">More Info</button>
				</a>
			</div>
			<div>
				<h2>Resilient Infrastructure for Sustainable Communities</h2>
				<p>
					This workshop aims to generate initiatives into research supporting
					innovations in designing, constructing and maintaining building stock
					and other civil infrastructure to be more resilient and sustainable.
				</p>
				<a href="http://www.nsf.gov/awardsearch/showAward?AWD_ID=1413857">
					<button className="btn btn-default">More Info</button>
				</a>
			</div>
			<div>
				<h2>Influenza Transmission and the Built Environment</h2>
				<p>
					In March 2014 engineers, designers, and researchers from around the
					world met at the SESYNC headquarters in Annapolis, MD. There they
					attended a workshop that explored creative new approaches to solving
					transmission problems of airborne infections in sustainable and
					healthy buildings.
				</p>
				<a href="http://www.sesync.org/project/influenza-transmission-and-the-built-environment">
					<button className="btn btn-default">More Info</button>
				</a>
				<a href="http://www.sesync.org/blog/influenza-transmission-built-environment">
					<button className="btn btn-default">News Article</button>
				</a>
			</div>
			<div>
				<h2>
					Measurement Science For Sustainable Construction and Manufactureing
				</h2>
				<p>
					A major need for achieving sustainable construction and manufacturing
					is to establish meaningful measurements for the complex attributes of
					sustainability suitable for lifecycle considerations. What one can
					measure, one can manage. NIST, ASCE, ASME and the University of
					Maryland are holding a workshop to address this challenge. Workshop
					will take place on June 12-13 at the ASCE Bechtel Center in Dulles, VA
				</p>
				<a href="http://www.asce.org/uploadedFiles/aei/Conferences/SusNISTAnnouncement20140128.pdf">
					<button className="btn btn-default">More Info</button>
				</a>
				<a href="https://docs.google.com/forms/d/1EZMsJQc9YkDmM565diA7KgWXfQfQPAEbNhitOHVstEc/viewform">
					<button className="btn btn-default">Sign Up</button>
				</a>
			</div>
			<br />
		</Container>
	);
}
export default Workshops;
